export default class Contact {
    constructor(){
        this.init()
    }
    init(){
        let maps = Array.from(document.querySelectorAll('.map-wrapper .contact-map'));
        if(maps) maps.forEach(mapEl=>this.renderMap(mapEl));
        if(document.querySelector('.map-controls'))
            this.geocoder = new google.maps.Geocoder();
    }
    checkBox(e, el){
        e.preventDefault();
        el.parentElement.querySelector('input').checked = true;
    }
    submitForm(event, form){
        event.preventDefault();
        let xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/contact-form');
        let formWrapper = form.parentElement;
        let oldError = formWrapper.querySelector('.oops');
        if(oldError) oldError.parentElement.removeChild(oldError);
        let button = formWrapper.querySelector('button');
        button.setAttribute('disabled', '');
        xhr.onload = function () {
            button.removeAttribute('disabled');
            if (xhr.status === 200) {
                formWrapper.innerHTML = '<h2>Thank You</h2><p></p>';
                formWrapper.querySelector('p').innerHTML = xhr.responseText;
            } else {
                let oops = document.createElement('div');
                oops.classList.add('oops');
                oops.innerHTML = '<h2>Oops...</h2><p>Something went wrong, sorry.</p>';
                let buttonWrap = button.parentElement;
                buttonWrap.parentElement.insertBefore(oops, buttonWrap);
            }
        }.bind(this);
        xhr.send(new FormData(form));
    }
    renderMap(mapEl){
        let pos = JSON.parse(mapEl.innerHTML);
        if(!pos) {
            mapEl.parentElement.removeChild(mapEl);
        } else {
            let map = new google.maps.Map(mapEl, {
                zoom: 15,
                center: pos,
                styles: [
                    {stylers: [{ hue: "#d2d2d2" }, { saturation: -100 }]},
                    {featureType: "road", elementType: "geometry",
                        stylers: [{ lightness: 100 }, { visibility: "simplified" }]},
                    {featureType: "road", elementType: "labels",
                        stylers: [{ visibility: "on" }]},
                    {featureType: 'poi.business', elementType: 'geometry',
                        stylers: [{ hue: '#ebd3ce' }, { saturation: 32 },
                            { lightness: 10 }, { visibility: 'on' }]}]
            });
            window.marker = new google.maps.Marker({
                position: pos,
                icon: {anchor:{x:28.5,y:40},url:'/icons/newmark-map-pin.svg?v=1',scaledSize:{width:57,height:60}},
                map: map,
            });
        }
    }
    geocode(address, goodResult, badResult){
        if(this.geocoder){
            this.geocoder.geocode({address},(results, status)=>{
                if(status==='OK'){
                    goodResult({location: results[0].geometry.location, viewport: results[0].geometry.viewport});
                } else badResult();
            });
        }
    }
    generateMap(event, form){
        event.preventDefault();
        let component = form.parentElement.parentElement;
        let mapWrapper = component.querySelector('.map-wrapper');
        let address = form.querySelector('.geocode-address').value;
        let dataSlot = component.querySelector('.map-slot [data-slot]');
        mapWrapper.innerHTML = '';
        dataSlot.innerHTML = '';
        this.geocode(address, (geocode)=>{
            let map = document.createElement('div');
            map.classList.add('contact-map');
            map.innerHTML=JSON.stringify(geocode.location);
            map.setAttribute('allow-wide','');
            mapWrapper.appendChild(map);
            dataSlot.appendChild(map.cloneNode(true));
            this.renderMap(map);
        }, ()=>mapWrapper.innerHTML='<h3 class="red">Results not found</h3>');
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/contact.js